/* eslint-disable no-unused-vars */
import { rootStore } from 'cv-react-core';

const getTheme = () => {
    const { themeStore } = rootStore;
    const theme = themeStore.getSanitizedTheme();

    // Populate the component parts with theme styles
    return {
        container: {
        },

        disabled: {
        },

        thumb: {
            backgroundColor: theme.checkBoxButtonColor,
        },

        track: {
            backgroundColor: theme.checkBoxUnCheckedBackgroundColor,
        },

        rail: {
            color: theme.checkBoxCheckedBackgroundColor,
        },

        trackContainer: {
            color: theme.checkBoxButtonColor,
        },
    };
};

export default getTheme;
